/* eslint-disable @atlaskit/editor/no-re-export */
// Entry file in package.json

import { RelativeSelectionPos } from '@atlaskit/editor-common/selection';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export var selectionPluginKey = new PluginKey('selection');
export { RelativeSelectionPos };
export var SelectionDirection = /*#__PURE__*/function (SelectionDirection) {
  SelectionDirection[SelectionDirection["Before"] = -1] = "Before";
  SelectionDirection[SelectionDirection["After"] = 1] = "After";
  return SelectionDirection;
}({});